module.exports = __webpack_public_path__ + "static/media/ruby.2c95cbc8.png";